import { FC, useMemo, useCallback } from 'react'
import styles from 'components/features/socialFeed/SocialInsightGroup/SocialInsightGroup.styl'
import { SocialInsightCard } from 'components/features/socialFeed/SocialInsightCard/SocialInsightCard'
import { OpportunityCategoryId } from 'interfaces/meta'
import { SocialInsight } from 'components/features/socialFeed/SocialInsight/SocialInsight'
import Button from 'components/features/pfm/Button/Button'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { opportunityCategoryTitlesSelector, createOpportunitiesCategoryGroupSelector } from 'selectors/oppertunitiesSelectors'
import SvgIcon from 'components/atoms/SvgIcon'
import { setFilterCategoryActionCreator } from 'actions/globalActions'
import { activateAnchorActionCreator } from 'actions/navigationActions'
import { WithPlacement } from 'interfaces/insights'
import { OpportunityPlacement } from 'interfaces/opportunities'
import { SOCIAL_INSIGHT_PAGES_BY_PLACEMENT } from 'constants/insights'

type SocialInsightGroupProps =
  & WithPlacement<OpportunityPlacement>
  & {
    categoryId: OpportunityCategoryId

  }

export const SocialInsightGroup: FC<SocialInsightGroupProps> = (props) => {
  const { categoryId, placement } = props
  const titles = useStoreSelector(opportunityCategoryTitlesSelector)
  const insightsSelector = useMemo(() => createOpportunitiesCategoryGroupSelector(placement), [placement])
  const insights = useStoreSelector((state) => insightsSelector(state, categoryId))

  const children = useMemo(() => {
    if (!insights || insights.length === 0) {
      return null
    }
    return insights.map((insight, index) => (
      <div key={ index } className={ styles.insight }>
        <SocialInsight
          uid={ insight.socialInsightUid }
          index={ index }
          theme='top-opportunities'
          isDismissible={ false }
        />
      </div>
    ))
  }, [insights])

  const iconChild = useMemo(() => {
    const iconSource = require(`icons/${ categoryId }.svg`).default
    return <SvgIcon src={ iconSource } />
  }, [categoryId])

  const dispatch = useStoreDispatch()

  const handleSeeAll = useCallback(() => {
    const page = SOCIAL_INSIGHT_PAGES_BY_PLACEMENT[placement]
    dispatch(setFilterCategoryActionCreator(page, categoryId))
    dispatch(activateAnchorActionCreator(page))
  }, [categoryId, dispatch, placement])

  const footerChild = (
    <a className={ styles.footer } onClick={ handleSeeAll }>
      <Button style='textOnly' size='mini'>
        <span className={ styles.seeAllContent }>
          See all { titles[categoryId] }
          <span className={ styles.seeAllArrow } />
        </span>
      </Button>
    </a>
  )

  if (!insights || insights.length === 0) {
    return null
  }

  return (
    <SocialInsightCard footerChild={ footerChild }>
      <div className={ styles.header } onClick={ handleSeeAll }>
        <div className={ styles.iconWrapper }>
          <div className={ styles.icon }>
            { iconChild }
          </div>
        </div>
        <div className={ styles.title }>
          { titles[categoryId] }
        </div>
      </div>
      <div>
        { children }
      </div>
    </SocialInsightCard>
  )
}
